import React from "react";
import { StyleSheet, Text, TouchableOpacity, View } from "react-native";
import * as Linking from "expo-linking";
import { useRouter } from "expo-router";
import { Home } from "lucide-react-native";

import { WEB_PRIVACY_URL, WEB_TERMS_URL } from "@/utils/links";

function NativeFooter(): React.JSX.Element {
  const router = useRouter();

  const currentYear = new Date().getFullYear();

  const onHomePress = (): void => {
    router.push("/");
  };

  const openTermsLink = (): void => {
    Linking.openURL(WEB_TERMS_URL);
  };

  const openPrivacyLink = (): void => {
    Linking.openURL(WEB_PRIVACY_URL);
  };

  const openDiagnosticLink = (): void => {
    router.replace("/diagnostics");
  };

  return (
    <View style={styles.container}>
      <TouchableOpacity
        testID="home-button"
        style={styles.homeButton}
        onPress={onHomePress}
        accessibilityLabel="Home"
        accessibilityRole="button"
      >
        <Home testID="home-icon" color="#4299E1" size={24} />
      </TouchableOpacity>
      <View style={styles.footer}>
        <Text style={styles.copyrightText}>
          © {currentYear} Kai Social. All rights reserved.
        </Text>
        <View style={styles.footerLinks}>
          <TouchableOpacity onPress={openPrivacyLink}>
            <Text style={styles.footerLinkText}>Privacy Policy</Text>
          </TouchableOpacity>
          <TouchableOpacity onPress={openTermsLink}>
            <Text style={styles.footerLinkText}>Terms of Service</Text>
          </TouchableOpacity>
          <TouchableOpacity onPress={openDiagnosticLink}>
            <Text style={styles.footerLinkText}>Diagnostics</Text>
          </TouchableOpacity>
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
  homeButton: {
    alignSelf: "center",
  },
  footer: {
    marginTop: 11,
    alignItems: "center",
  },
  copyrightText: {
    fontSize: 12,
    color: "#718096",
    marginBottom: 10,
  },
  footerLinks: {
    flexDirection: "row",
  },
  footerLinkText: {
    color: "#4299E1",
    fontSize: 12,
    marginHorizontal: 5,
  },
});

export default NativeFooter;
